const frameMenus = [
  { index: 'home', icon: 'el-icon-house', label: '首页' },
  { index: 'appointView', icon: 'el-icon-document', label: '预约记录' },
  { index: 'pavilionAppoint', icon: 'el-icon-discount', label: '面试亭' },
  { index: 'questCenter', icon: 'el-icon-edit', label: '测评中心' },
  { index: 'personalData', icon: 'el-icon-user', label: '我' }
]

/**
 *
 * @param {Number} consult_SmartPavilion
 * 1: 面试亭
 * 2: 咨询
 * 3: 咨询+面试亭
 */
export function getFrameMenus(consult_SmartPavilion ,open_homepage) {

  consult_SmartPavilion = consult_SmartPavilion || 2
  if (typeof consult_SmartPavilion !== 'number' || consult_SmartPavilion < 1 || consult_SmartPavilion > 3) {
    throw new Error('401');
  }

  let subMenus = [];

  switch (consult_SmartPavilion) {
    case 1:
      subMenus.push(frameMenus[2], frameMenus[4]); // 取第三和第五个元素
      break;
    case 2:
      subMenus.push(frameMenus[0], frameMenus[1], frameMenus[3], frameMenus[4]); // 取1,2,4,5
      break;
    case 3:
      subMenus = frameMenus; // 取1,2,3,4,5
      break;
    default:
      throw new Error('401');
  }
  if (consult_SmartPavilion > 1 && open_homepage === 'questCenter'){
    subMenus = [];
    subMenus.push(frameMenus[3], frameMenus[4]); // 取第4和第五个元素
  }

  return subMenus;
}

export function goBack() {
  this.$router.go(-1);
}
